import React, { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { Menu, Transition } from "@headlessui/react";
import ReactPaginate from "react-paginate";
//import icone
import { RiSearch2Line } from "react-icons/ri";
import ClearFilter from "../../images/clear filter icon.png";
import LimitArrow from "../../images/LimitArrow.svg";
import Loader from "../../component/Admin/Loader";
import { EditEmployeeModal } from "../../component/Modal/AdminModal/EditEmployeeModal";
import {  ExportMasterBranchData, GetAllBranchlist, GetMasterMemberlist,  MasterAdminLoader } from "../../Redux/Action/MasterAdminAction";
import UseOutsideClick from "../../component/Admin/UseOutsideClick";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import calender from "../../images/Doctor/calender.png";
import { components } from "react-select";
import AdminLayout from "../../component/layout/AdminLayout/AdminLayout";
import { ToastContainer } from "react-toastify";
import { Filter } from "lucide-react";
import VfsFilterSidebar from "../../component/Admin/VfsFilterSidebar";
import { ExportRangeSelectModel } from "../../component/Modal/AdminModal/ExportRangeSelectModel";
import ExportModel from "../../component/common/ExportModel";

const AdminVfs = () => {
  const location = useLocation();
  const history = useNavigate();
  const dispatch = useDispatch();
  const [selectpage, setselectpage] = useState("");
  const itemsPerPageOptions = [
    { value: 10, label: 10, id: 1 },
    { value: 25, label: 25, id: 2 },
    { value: 50, label: 50, id: 3 },
  ];

  const Employeelist = useSelector(
    (state) => state?.MasterAdmin?.AllMasterData?.data
  );

  useEffect(() => {
    searchParams.delete("search");
    searchParams.delete("corporateID");
    searchParams.delete("startDate");
    searchParams.delete("endDate");
    setSearchParams(searchParams);
    const sds = location.search.slice(1).split("&");

    let object = {};
    if (location.search.includes("?")) {
      sds.map((item) => {
        let newItem = item.split("=");
        object[newItem[0]] = newItem[1];
      });
    }
    delete object.search;
    delete object.corporateID;
    delete object.startDate;
    delete object.endDate;
    dispatch(GetMasterMemberlist({ ...object }));
    dispatch(GetAllBranchlist());
  dispatch(MasterAdminLoader());
  }, []);

  const [Itemperpage, setItemperpage] = useState("");
  const [page, setpage] = useState("");
  const pageCount = Math.ceil(Number(Employeelist?.count) / Number(page));

  useEffect(() => {
    if (pageCount && pageCount !== Infinity) {
      setItemperpage(pageCount);
    }
  }, [Employeelist]);

  useEffect(() => {
    setpage(itemsPerPageOptions[0]?.value);
  }, []);

  // for select page data
  const onselectedpage = (item) => {
    setpage(item.value);
  
    // Parse the current query string into an object
    const searchParams = new URLSearchParams(location.search);
    let params = {};
  
    searchParams.forEach((value, key) => {
      if (key === 'corporateID') {
        // If 'corporateID' already exists, append the new value
        params[key] = [...(params[key] || []), value];
      } else {
        // Otherwise, just set the value
        params[key] = value;
      }
    });
  
    // Ensure 'corporateID' is an array
    if (params.corporateID && !Array.isArray(params.corporateID)) {
      params.corporateID = [params.corporateID];
    }
  
    // Update the 'limit' and 'page' parameters
    params.limit = item.value;
    params.page = 1;
  
    // Construct the new query string
    const updatedSearchParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(val => updatedSearchParams.append(key, val));
      } else {
        updatedSearchParams.set(key, value);
      }
    });
  
    // Update the URL without reloading the page
    history({
      pathname: "/admin/admin_user/master",
      search: "?" + updatedSearchParams.toString(),
    });
  
    const params1 = {
      ...filters,
      page: 1,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: item.value,
      search: Search,
    };
    // Dispatch the action to fetch the member list
    dispatch(GetMasterMemberlist(params1));
  dispatch(MasterAdminLoader());
  };

  // for pagination
  const handleFirstPage = () => {
    setselectpage(0);
    const params = {
      ...filters,   // include current filters here
      page: 1,
      search: Search,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
    };
    // Dispatch the action to fetch the member list
    dispatch(GetMasterMemberlist(params));
  dispatch(MasterAdminLoader());
  };
  const handleLastPage = () => {
    const lastPage = pageCount - 1;
    setselectpage(lastPage);
    const params = {
      ...filters,   // include current filters here
      page: lastPage + 1,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      search: Search,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
    };
    // Dispatch the action to fetch the member list
    dispatch(GetMasterMemberlist(params));
  dispatch(MasterAdminLoader());
  };
  const handlePageChange = (selected) => {
    setselectpage(selected.selected);
    const params = {
      ...filters,   // include current filters here
      page: selected.selected + 1,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : 10,
      search: Search,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
    };
    // Dispatch the action to fetch the member list
    dispatch(GetMasterMemberlist(params));
  dispatch(MasterAdminLoader());
  };  

  //for search filter
  const [Search, setSearch] = useState("");
  const submitsearch = (e) => {
    e?.preventDefault();
   
    const params = {
      ...filters,
      search: Search,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
      page: 1,
    };
    dispatch(GetMasterMemberlist(params));
  dispatch(MasterAdminLoader());
  };

  const [searchParams, setSearchParams] = useSearchParams();

  const removeQueryParams = () => {
    const params = {
      ...filters,
      search: '',
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
      page: 1,
    };
    dispatch(GetMasterMemberlist(params));
  dispatch(MasterAdminLoader());
    setselectpage(0);
  };
  
  // for searchable-dropdwon
  const [selectedCorporate, setSelectedCorporate] = useState([]);
  const [optionList, setOptionList] = useState([]);
  const [error, setError] = useState("");


  const CheckboxOption = (props) => {
    return (
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null} // prevent default behavior
          className="mr-2"
        />
        <label>{props.label}</label>
      </components.Option>
    );
  };

  function handleSelect(selectedOptions) {
    const selectedIds = selectedOptions?.map((opt) => opt.value) || [];
    setSelectedCorporate(selectedIds);
  
    const sds = location.search
      .slice(1)
      .split("&")
      .filter((item) => item.includes("="));
  
    let object = {};
  
    sds.forEach((item) => {
      let [key, value] = item.split("=");
  
      if (key !== "corporateID" && key !== "page" && value !== "undefined") {
        // Decode value
        value = decodeURIComponent(value).replace(/\+/g, " ");
        object[key] = value;
      }
    });
  
    // Force page = 1
    object.page = 1;
  
    const searchParams = new URLSearchParams();
    Object.entries(object).forEach(([key, value]) => {
      searchParams.set(key, value);
    });
  
    selectedIds.forEach((id) => {
      searchParams.append("corporateID", id);
    });
  
    history({
      pathname: "/admin/admin_user/master",
      search: `?${searchParams.toString()}`,
    });
  
    dispatch(
      GetMasterMemberlist({
        ...object,
        corporateID: selectedIds,
      })
    );
  dispatch(MasterAdminLoader());
  }  

  const Corporatename = useSelector(
    (state) => state?.MasterAdmin?.AllBranchList?.data
  );
  const AllMasterMemberList = useSelector(
    (state) => state?.MasterAdmin?.AllMasterMemberList?.data
  );

  useEffect(() => {
    const con =
      Corporatename &&
      Corporatename?.map((c) => ({
        value: c._id,
        label: c.corporateName,
        color: c.status ? "black" : "#808080",
      }));
    setOptionList(con);
  }, [Corporatename]);

  const [selectedMasterCorporate, setselectedMasterCorporate] = useState("");
  const [masteroptionList, setMasteroptionList] = useState([]);
  useEffect(() => {
    const con =
      AllMasterMemberList &&
      AllMasterMemberList?.map((c) => ({
        value: c._id,
        label: c.corporateName,
        color: c.status ? "black" : "#808080",
      }));
    setMasteroptionList(con);
  }, [AllMasterMemberList]);


  function handleSelectmaster(selectedOption) {
    const selectedId = selectedOption?.value || "";
    setselectedMasterCorporate(selectedId);
    dispatch(GetAllBranchlist(selectedId));
  
    const sds = location.search
      .slice(1)
      .split("&")
      .filter((item) => item.includes("="));
  
    let object = {};
    let currentMasterId = "";
  
    sds.forEach((item) => {
      const [key, value] = item.split("=");
  
      if (key === "master_CorpoId") {
        currentMasterId = value;
      } else {
        if (value !== "undefined") {
          if (key === "corporateID") {
            if (!object[key]) object[key] = [];
            object[key].push(value);
          } else if (key !== "page") { //  Ignore old page key
            object[key] = value;
          }
        }
      }
    });
  
    const isSameMaster = selectedId === currentMasterId;
  
    if (!isSameMaster) {
      delete object.corporateID;
      setSelectedCorporate([]);
    }
  
    const updatedParams = {
      ...object,
      master_CorpoId: selectedId,
      page: 1, //  Force page = 1
    };
  
    const searchParams = new URLSearchParams();
    Object.entries(updatedParams).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach((v) => searchParams.append(key, v));
      } else {
        searchParams.set(key, value);
      }
    });
  
    history({
      pathname: "/admin/admin_user/master",
      search: `?${searchParams.toString()}`,
    });
  
    dispatch(GetMasterMemberlist(updatedParams));
  dispatch(MasterAdminLoader());
  }
  
  
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minWidth: '150px',
      maxWidth: window?.innerWidth > 600 && '210px',
      borderColor: state.isFocused ? '#fff100' : '#ececec',
      boxShadow: 'none',
      '&:hover': { borderColor: '#ececec' },
    }),
    placeholder: (base) => ({
      ...base,
      color: '#262626',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '2px 8px',
      height: '38px',
      overflow: 'hidden',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      color: '#262626',
      height: '38px',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: 'transparent',
      color: 'black',
      display: 'flex',
      alignItems: 'center',
      '&:hover': {
        backgroundColor: '#f8f8f8',
      },
    }),
    menuList : (provided) => ({
      ...provided,
      maxHeight : '200px',
      overflowY : 'auto',
      padding: 0,
    }),
  };

  useEffect(() => {
    const newlimit = searchParams.get("limit");
    if (newlimit?.length > 0) {
      setpage(newlimit);
    }
  }, []);

  useEffect(() => {
    const newcorporateID = searchParams.get("corporateID");
    if (newcorporateID?.length > 0 && newcorporateID !== null) {
      setSelectedCorporate(newcorporateID);
    }
  }, []);

  useEffect(() => {
    const newcorporateID = searchParams.get("master_CorpoId");
    if (newcorporateID?.length > 0 && newcorporateID !== null) {
      setselectedMasterCorporate(newcorporateID);
    }
  }, []);

  useEffect(() => {
    const newpage = searchParams.get("page");
    if (newpage?.length > 0 && newpage !== null) {
      setselectpage(newpage - 1);
    }
  }, [searchParams]);

  const [showdelete, setshowdelete] = useState(false);
  const [selectionRange, setSelectionRange] = useState(null);

  useEffect(() => {
    if (selectedCorporate?.length > 0 || selectionRange?.startDate || selectionRange?.endDate || selectedMasterCorporate?.length > 0) {
      setshowdelete(true);
    } else {
      setshowdelete(false);
    }
  }, [selectedCorporate, selectionRange , selectedMasterCorporate]);

  const handlecorporatedelete = () => {
    searchParams.delete("corporateID");
    searchParams.delete("startDate");
    searchParams.delete("endDate");
    searchParams.delete("master_CorpoId");
  
    setSelectionRange(null);
    setopenCalender(false);
    setselectedMasterCorporate("");
    setSelectedCorporate([]);
    setSearchParams(searchParams);
  
    const sds = location.search.slice(1).split("&");
    let object = {};
  
    if (location.search.includes("?")) {
      sds.forEach((item) => {
        const [key, value] = item.split("=");
        if (
          key &&
          value &&
          key !== "corporateID" &&
          key !== "startDate" &&
          key !== "endDate" &&
          key !== "master_CorpoId"
        ) {
          object[key] = decodeURIComponent(value).replace(/\+/g, " ");
        }
      });
    }
  
    dispatch(GetMasterMemberlist({ ...object }));
  dispatch(MasterAdminLoader());
  };
  

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  //for pagination
  const reactPaginate = {
    previousLabel: "<",
    nextLabel: ">",
    breakLabel: "",
    pageCount: Itemperpage,
    onPageChange: handlePageChange,
    containerClassName: "pagination",
    previousLinkClassName: "pagination__link",
    nextLinkClassName: "pagination__link",
    disabledClassName: "pagination__link--disabled",
    activeClassName: "pagination__link--active",
    forcePage: selectpage,
  };

  // for loader
  const loader = useSelector((state) => state?.MasterAdmin?.corporateloader);

  const [editEmpModel, setEditEmpModel] = useState(false);
  const [userDetail, setuserDetail] = useState("");

  const [openCalender, setopenCalender] = useState(false);
  const [unixstartDate, setUnixStartDate] = useState(new Date(new Date().setUTCHours(0, 0, 0, 0))?.getTime());
  const [unixendDate, setUnixendDate] = useState(new Date(new Date().setUTCHours(23, 59, 59, 999))?.getTime());
  function formatDate(date) {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return date.toLocaleDateString(undefined, options);
  }

  const ref = useRef();
  UseOutsideClick(ref, () => {
    if (openCalender) {
      setopenCalender(false);
    }
  });

  const handleSelection = (range) => {
    setSelectionRange({
      startDate: range.selection.startDate,
      endDate: range.selection.endDate,
      key: "selection",
    });
  
    const startDateText = formatDate(range.selection.startDate);
    const endDateText = formatDate(range.selection.endDate);
  
    const unix_timestamp = new Date(
      new Date(startDateText).setUTCHours(23, 59, 59, 999)
    ).getTime();
  
    const unix_timestamp1 = Math.floor(
      new Date(endDateText).getTime() + 86400000
    );
  
    setUnixStartDate(unix_timestamp);
    setUnixendDate(unix_timestamp1);
  
    const sds = location.search.slice(1).split("&").filter(Boolean);
    let object = {};
  
    sds.forEach((item) => {
      const [key, value] = item.split("=");
      if (!key || typeof value === "undefined") return;
  
      const decodedKey = decodeURIComponent(key);
      const decodedValue = decodeURIComponent(value);
  
      if (decodedKey === "page") return;
  
      if (decodedKey === "corporateID") {
        if (!object[decodedKey]) object[decodedKey] = [];
        object[decodedKey].push(decodedValue);
      } else {
        object[decodedKey] = decodedValue;
      }
    });
  
    const updatedParams = {
      ...object,
      startDate: unix_timestamp,
      endDate: unix_timestamp1,
      page: 1,
    };
  
    const searchParams = new URLSearchParams();
    Object.entries(updatedParams).forEach(([key, val]) => {
      if (Array.isArray(val)) {
        val.forEach((v) => searchParams.append(key, v));
      } else {
        searchParams.set(key, val);
      }
    });
  
    history({
      pathname: "/admin/admin_user/master",
      search: `?${searchParams.toString()}`,
    });
  
    const params = {
      ...filters,
      startDate: unix_timestamp,
      endDate: unix_timestamp1,
      search: Search,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
      page: 1,
    };
    dispatch(GetMasterMemberlist(params));
  dispatch(MasterAdminLoader());
  };
  

  function formattedStartDate(d) {
    let month = String(d?.getMonth() + 1);
    let day = String(d?.getDate());
    const year = String(d?.getFullYear());

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return `${day}/${month}/${year}`;
  }
  const [showDateWarning, setShowDateWarning] = useState(false);
  const [showExportModel,setShowExportModel] = useState(false);
  
const handleExportData = (enteredEmail) => {
  if (!selectionRange) {
    setShowDateWarning(true);
    return; // Stop export
}
  if(!showExportModel){
    setShowExportModel(true);
    return;
}
  const sds = location.search.slice(1).split("&");
  let object = {};

  if (location.search.includes("?")) {
    sds.forEach((item) => {
      const [key, rawValue] = item.split("=");

      const value = decodeURIComponent(rawValue || "");

      if (object[key]) {
        if (Array.isArray(object[key])) {
          object[key].push(value);
        } else {
          object[key] = [object[key], value];
        }
      } else {
        object[key] = value;
      }
    });
  }
const params = {
    ...filters,
    search: Search,
    startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
    endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
  };
  // Dispatch the export action
  dispatch(ExportMasterBranchData({ ...params ,email:enteredEmail}));
  dispatch(MasterAdminLoader());
};

const formatToIST = (ms) => {
  const date = new Date(ms);

  return new Intl.DateTimeFormat('en-IN', {
    timeZone: 'Asia/Kolkata',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  })
    .format(date)
    .replace(',', '');
};


  // filter changes
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const toggleSidebar = () => {
      setIsSidebarOpen(!isSidebarOpen);
    };

    const [filters, setFilters] = useState({
      corporateID: [],
      startDate: null,
      endDate: null,
    });

    const handleFilterChange = (newFilters) => {
      setFilters(newFilters);
      return true;
    };

    const getActiveFilterCount = () => {
      if(selectionRange?.key === "selection"){
        return filters.corporateID.length + 1;
      }
      return filters.corporateID.length;
    };

    const clearAllFilters = () => {
      setFilters({
        corporateID: [],
      });
      handleFilterChange({
        corporateID: [],
      });
      setSelectionRange(null);
      searchParams.delete("startDate");
    searchParams.delete("endDate");
    setSearchParams(searchParams);
    setselectpage(0);
      dispatch(
        GetMasterMemberlist({
          corporateID: [],
          search: Search,
          page: 1,
        })
      );
  dispatch(MasterAdminLoader());
      setIsSidebarOpen(false);
    };


  const handelApplyFilter = (filters) => {
    setFilters(filters);
    dispatch(GetMasterMemberlist({
      ...filters,
      page: 1,
      search: Search,
      startDate: searchParams.get("startDate") ? searchParams.get("startDate") : null,
      endDate: searchParams.get("endDate") ? searchParams.get("endDate") : null,
      limit: searchParams.get("limit") ? searchParams.get("limit") : null,
    }));
  dispatch(MasterAdminLoader());
  }; 

  return (
    <>
      {loader && (
        <div>
          <div className="bg-black fixed  top-0 left-0 right-0 w-full h-full z-40 bg-opacity-50">
            <div className="z-[50] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <Loader />
            </div>
          </div>
        </div>
      )}
      <ToastContainer />
      <AdminLayout>
        <div className="flex flex-col h-[calc(100vh-58px)] px-5 py-5 2xl:justify-between">
          {/* {/ --------------------------------------------Search Bar---------------------------------------------------------- /} */}
          <div className="bg-white p-4 rounded-lg  w-full mb-5">
            <div className=" flex flex-col xl:flex-row gap-3 md:gap-0  justify-start items-start xl:justify-between xl:items-center">
              <div className="relative flex items-center gap-3">
                <div className="absolute top-[8px] left-[20px] text-gray-400 text-2xl">
                  <RiSearch2Line className="w-6 h-6" />
                </div>
                <form
                  onSubmit={(e) => {
                    e?.preventDefault();
                    if (Search.trim() !== "") {
                      submitsearch(e);
                    }
                  }}
                >
                  <input
                    className="h-full bg-[#FFFCE1] border rounded-[8px] py-2 pl-[50px] w-[250px] md:w-[320px] placeholder:text-[#47505F]  placeholder:text-[14px] placeholder:font-medium outline-[#FCDD00]"
                    placeholder="Search By Member, Email, Contact No"
                    value={Search}
                    type="text"
                    onChange={(e) => {
                      const inputValue = e.target.value.trimStart();
                      setSearch(inputValue);
                      if (inputValue.trim() === "") {
                        removeQueryParams();
                      }
                    }}
                  />
                </form>
                <p className="text-sm font-semibold">Total Member : {Employeelist && Employeelist?.count}</p>
              </div>
              <div className=" flex flex-wrap items-center xl:justify-end rounded-[8px] gap-3 mt-3 xl:mt-0">
                
              {getActiveFilterCount() > 0 && (
                  <div className="flex gap-3 z-10 ">
                    <button
                      className="bg-[#fae006] hover:bg-[#fae006]/80 py-1 px-2  rounded-[4px] del-tooltip "
                      onClick={clearAllFilters}
                    >
                      <div className="flex items-center gap-2 ">
                      <img src={ClearFilter} className=" w-7 h-7" alt="new"></img>
                      </div>
                      <span className="del-tooltiptext  font-Poppins text-sm">Clear Filter</span>
                    </button>
                  </div>
                )}
              <button
                  onClick={toggleSidebar}
                  className="inline-flex items-center px-4 py-2  rounded-lg text-sm font-medium  bg-[#fae006] hover:bg-[#fae006]/80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
                >
                  <Filter className="w-4 h-4 mr-2" />
                  Filters
                </button>
                <div className=" relative ">
                  <button
                    className=" bg-[#fae006] text-sm items-center flex px-4 rounded-[8px] py-2 font-medium"
                    onClick={() => setopenCalender(!openCalender)}
                  >
                    <img src={calender} className="mr-[12px] w-4 h-4" alt="calenderimg"></img>
                    {selectionRange
                      ? `${formattedStartDate(
                          selectionRange.startDate
                        )} - ${formattedStartDate(selectionRange.endDate)}`
                      : "Select Date"}
                  </button>
                  {openCalender && (
                    <div className=" absolute md:right-0 z-50" ref={ref}>
                      <DateRangePicker
                        ranges={[
                          selectionRange || {
                            startDate: new Date(),
                            endDate: new Date(),
                            key: "selection",
                          },
                        ]}
                        onChange={handleSelection}
                        rangeColors={["#FCDD00"]}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        maxDate={new Date()}
                        popperProps={{
                          strategy: "fixed",
                        }}
                        direction="horizontal"
                      />
                    </div>
                  )}
                </div>
                {Employeelist?.corporateData?.length > 0 && (
                <button className=" bg-[#fae006] text-sm flex px-4 rounded-[8px] py-2 font-medium disabled:bg-[#fae006]/80 disabled:cursor-not-allowed" onClick={() => handleExportData()} disabled={!Employeelist?.corporateData?.length}>
                  Export
                </button>
                )}
              </div>

              {error && <p className="text-[#ff0000]">{error}</p>}
            </div>
          </div>
          {/* {/ --------------------------------------------Content Table------------------------------------------------------- /} */}
          <div className="flex-1 overflow-auto scrollbar-thumb-[#FCDD00] scrollbar-thin scrollbar-track-gray-100">
            {Employeelist?.corporateData?.length === 0 ? (
              <div className="flex justify-center items-center h-full">
                <p className="font-Roboto text-xl ">
                  No Member Details Available.
                </p>
              </div>
            ) : (
              <table className="corporate-table w-[100%]  text-left font-Poppins">
                <thead>
                  <tr style={{ zIndex: 5 }}>
                    <th>
                      <div className="pl-[40px] py-3 xl:py-5 min-w-[220px]">
                        Branch Name
                      </div>
                    </th>
                    <th>
                      <div className="min-w-[160px]">Member Name</div>
                    </th>
                    <th>
                      <div className="min-w-[190px]">Email Id</div>
                    </th>
                    <th>
                      <div className="min-w-[120px]">Contact No.</div>
                    </th>
                    <th>
                      <div className="min-w-[150px]">Destination Country</div>
                    </th>
                    <th>
                      <div className="min-w-[180px]">Register Date</div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Employeelist?.corporateData?.map((user, index) => (
                    <tr key={index}>
                      <td className="pl-[40px] capitalize py-2 xl:py-4 h-[46px]">
                        {user?.branchName && user?.branchName ? (
                          user.branchName?.length > 17 ? (
                            <div className="tooltip">
                              <span className="">
                                {user.branchName?.substring(0, 17)}...
                              </span>
                              <span className="tooltiptext ">
                                {user.branchName}
                              </span>
                            </div>
                          ) : (
                            <span className="">{user.branchName}</span>
                          )
                        ) : (
                          <span>-</span>
                        )}
                      </td>
                      {user?.name?.length > 18 ? (
                        <td>
                          <div className="tooltip capitalize ">
                            {`${user?.name?.substring(0, 18)}...`}
                            <span className="tooltiptext ">{user.name}</span>
                          </div>
                        </td>
                      ) : (
                        <td className="capitalize ">
                          <div>{user.name}</div>
                        </td>
                      )}

                      {user?.email?.length >  30 ? (
                        <td>
                          <div className="tooltip ">
                            {`${user?.email?.substring(0, 30)}...`}
                            <span className="tooltiptext ">{user.email}</span>
                          </div>
                        </td>
                      ) : (
                        <td>
                          <div className="">{user.email}</div>
                        </td>
                      )}

                      <td><p className="">{user.contact}</p></td>
                      {user?.Destination_Country?.length > 15 ? (
                        <td>
                          <div className="tooltip capitalize ">
                            {`${user?.Destination_Country?.substring(0, 15)}...`}
                            <span className="tooltiptext ">
                              {user.Destination_Country}
                            </span>
                          </div>
                        </td>
                      ) : (
                        <td className="capitalize ">
                          {user.Destination_Country ? user.Destination_Country : "-"}
                        </td>
                      )}
                      <td><p className="">{user.created && formatToIST(user.created)}</p></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
          {/* {/ --------------------------------------------Footer---------------------------------------------------------- /} */}
          {Employeelist?.corporateData?.length > 0 && 
          <div className="footer-content mt-5 sticky bottom-0  bg-white ">
            <div className=" md:flex justify-between items-center ">
              <div className="flex gap-2 items-center mb-3 md:mb-0">
                <p className="capitalize">View</p>
                <div className="">
                  <Menu as="div" className="relative text-left">
                    <div>
                      <Menu.Button className="flex px-[10px] ml-[24px] min-h-[37px] bg-white border-2 border-[#F2F2F2] min-w-[60px] rounded-[8px] justify-between  text-sm font-poppins font-medium  items-center ">
                        <p className="text-[#47505F] font-medium font-[poppins]">
                          {page}
                        </p>
                        <img src={LimitArrow} alt="LimitArrow" />
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="bottom-full absolute right-0 z-10 mt-2 py-2 w-[70%] rounded-[12px] bg-white shadoe-sm focus:outline-none border  mb-2">
                        {itemsPerPageOptions?.map((e) => (
                          <div key={e?.id}>
                            <Menu.Item>
                              {({ active }) => (
                                <p
                                  className={classNames(
                                    active ? "bg-[#FFFCE1] text-[#1A1A1A]" : "",
                                    "block px-2 py-2 text-sm cursor-pointer"
                                  )}
                                  onClick={() => onselectedpage(e)}
                                >
                                  {e?.value}
                                </p>
                              )}
                            </Menu.Item>
                          </div>
                        ))}
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </div>
              </div>
              {/* {/ --------------------------------------------Footer Pagination---------------------------------------------------------- */}
              <div className="flex items-center mt-3 md:mt-0 ">
                <button
                  className="cursor-pointer text-[#000] text-base border border-[#D1D5DB] px-[15px] py-[4.5px] md:py-[5.5px]"
                  onClick={handleFirstPage}
                >
                  &lt;&lt;
                </button>
                <div className="hidden md:block">
                  <ReactPaginate
                    {...reactPaginate}
                    breakLabel="..."
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                  />
                </div>
              </div>
            </div>
          </div>
          }
        </div>
        {editEmpModel && <EditEmployeeModal {...{ setEditEmpModel, userDetail }} />}
        {isSidebarOpen && (
          <VfsFilterSidebar
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
            filters={filters}
            onFilterChange={handleFilterChange}
            optionList={optionList}
            selectedCorporate={selectedCorporate}
            Search={Search}
            vfsMemberList={false}
            startDate={searchParams.get("startDate")}
            endDate={searchParams.get("endDate")}
            setselectpage={setselectpage}
            handelApplyFilter={handelApplyFilter}
          />
        )}
        {/* Overlay */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-25 z-40 transition-opacity duration-300"
            onClick={() => setIsSidebarOpen(false)}
          />
        )}

        {showDateWarning && (
            <ExportRangeSelectModel
              openModel={showDateWarning}
              onClose={() => setShowDateWarning(false)}
            />
          )}
        {editEmpModel && (
          <EditEmployeeModal {...{ setEditEmpModel, userDetail }} />
        )}
        {showExportModel && (
          <ExportModel
            isOpen={showExportModel}
            onClose={() => setShowExportModel(false)}
            exportData={handleExportData}
          />
        )}
      </AdminLayout>
    </>
  );
};
export default AdminVfs;
